import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.use(VueAxios, axios);

const mutations = {
  MUTATION_UPDATE_SB_WORKGROUPS: function (state, data) {
    state.sbWorkgroups = data;
  }
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/shiftboard/mutations.js